import { useWindowDimensions } from 'spa/hooks';
import TransactionConstants from 'spa/constants/TransactionConstants';

const useFullWidthKycDetails = () => {
  const { width } = useWindowDimensions();
  const fullWidth = width < TransactionConstants.DESKTOP_VIEW_WIDTH;
  const fullWidthClassName = fullWidth ? '--fullWidth' : '';
  return { fullWidth, fullWidthClassName };
};

export default useFullWidthKycDetails;
